// Refund flag model shared by RefundStateBadge and the Sales hover card (kind 'refund'): flags, amounts, plain-words reasons. One source, no drift.
import { formatMoneyExact, formatDate } from '../../utils/format';

export const AMOUNT = { refunded: 'paid_out', collectable: 'payable_now', not_yet: 'held' };
export const LABEL = { refunded: 'paidOut', collectable: 'payableNow', not_yet: 'held' };
export const ORDER = ['refunded', 'collectable', 'not_yet'];
// back-compat: an old payload only has the primary refund_state
export const refundFlags = (row) => (Array.isArray(row?.refund_flags) ? row.refund_flags : row?.refund_state && row.refund_state !== 'none' ? [row.refund_state] : []);
export const orderedFlags = (row) => ORDER.filter(f => refundFlags(row).includes(f));

// { amounts, money, explain: {flag: sentence} } for a row; t = the 'sales' namespace translator
export function refundFigures(r, t) {
  const A = r.refund_state_amounts || {}, money = v => formatMoneyExact(Number(v) || 0);
  const S = k => `refundState.sentence.${k}`, why = r.refund_held_reason || r.refund_state_reason, date = r.refund_paid_on || A.paid_on;
  const explain = { collectable: t(S('payNow'), { amount: money(A.payable_now) }), refunded: date ? t(S('paidOn'), { amount: money(A.paid_out), date: formatDate(date) }) : '',
    not_yet: [why && t(S(why), { defaultValue: '' }), why === 'owes_elsewhere' && Number(A.owed_elsewhere) > 0 && t(S('owedElsewhere'), { owed: money(A.owed_elsewhere) })].filter(Boolean).join(' ') };
  return { A, money, explain };
}
